var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tile is-ancestor is-parent" },
    [
      _c("div", { staticClass: "tile is-parent is-vertical" }, [
        _c(
          "article",
          { staticClass: "tile is-child box" },
          [
            _c("div", { staticClass: "columns is-gapless" }, [
              _vm._m(0),
              !_vm.readOnlyView && _vm.poItems.length > 0
                ? _c("div", { staticClass: "column" }, [
                    _vm.$user.hasAdd(_vm.$route.meta.id)
                      ? _c("div", { staticClass: "control is-pulled-right" }, [
                          !_vm.isLockPurchaseOrder
                            ? _c("div", { staticClass: "field-body" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field",
                                    staticStyle: { "margin-right": "0.5em" },
                                  },
                                  [
                                    _c("div", { staticClass: "buttons" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button is-primary tooltip is-tooltip-topright",
                                          attrs: {
                                            "data-tooltip": "Add new labour",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addNewOrderReceipt()
                                            },
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "icon" }, [
                                            _c("i", {
                                              staticClass: "mdi",
                                              class: { "mdi-plus": true },
                                            }),
                                          ]),
                                          _c("span", [_vm._v(_vm._s("Add"))]),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _c("div", [_c("order-lock-notification")], 1),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _c(
              "bulma-table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
                attrs: {
                  columns: _vm.columns,
                  "page-index": 1,
                  "page-size": 100,
                  "total-rows": _vm.entitySummaries.length,
                  "show-pagination": false,
                  "is-loading": _vm.isTableLoading,
                  "sort-column": _vm.sortColumn,
                  "sort-order": _vm.sortOrder,
                },
                on: { sort: _vm.sort },
              },
              [
                _vm._l(_vm.entitySummaries, function (receipt, index) {
                  return _c(
                    "tr",
                    {
                      key: receipt.creditorInvoiceId,
                      class: { "is-selected": _vm.selectedRow === index },
                      on: {
                        click: function ($event) {
                          return _vm.highlightSelected(index, $event)
                        },
                      },
                    },
                    [
                      _c("td", { staticClass: "invoiceno-width" }, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.viewReceipt(
                                  receipt.creditorInvoiceId
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(receipt.invoiceNo))]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  (!receipt.isValid ||
                                    (receipt.abn != "" &&
                                      _vm.$v.entity.orderReceipts.$each[index]
                                        .$error)) &&
                                  receipt.receiptItems.length > 0,
                                expression:
                                  "(!receipt.isValid || (receipt.abn != '' && $v.entity.orderReceipts.$each[index].$error)) && receipt.receiptItems.length > 0",
                              },
                            ],
                            staticClass:
                              "icon has-text-danger tooltip is-tooltip-danger",
                            attrs: {
                              "data-tooltip":
                                "Please fix the order receipt error.",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "mdi mdi-alert-circle mdi-18px",
                            }),
                          ]
                        ),
                      ]),
                      _c("td", { staticClass: "invoicedate-width" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatDateTimezone(
                              receipt.invoiceDate,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "abn-width" }, [
                        _vm._v(_vm._s(receipt.abn)),
                      ]),
                      _c(
                        "td",
                        { staticClass: "has-text-centered is-content-width" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-primary is-small is-inverted tooltip",
                              attrs: { "data-tooltip": "Click to view" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewReceipt(
                                    receipt.creditorInvoiceId
                                  )
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon is-medium" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-file-document mdi-24px",
                                }),
                              ]),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.$user.hasDelete(
                                    _vm.$route.meta.id
                                  ),
                                  expression: "$user.hasDelete($route.meta.id)",
                                },
                              ],
                              staticClass:
                                "button is-danger is-small is-inverted tooltip is-tooltip-topright",
                              attrs: {
                                disabled: _vm.readOnlyView || receipt.exported,
                                "data-tooltip": "Click to delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteReceipt(receipt, index)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon is-medium" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-delete mdi-24px",
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                _c("template", { slot: "empty" }, [
                  _c("section", { staticClass: "section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "content has-text-grey has-text-centered",
                      },
                      [
                        _c("span", { attrs: { icon: "icon is-large" } }, [
                          _c("i", {
                            staticClass: "mdi mdi-48px mdi-emoticon-sad",
                          }),
                        ]),
                        _c("p", [_vm._v("Nothing")]),
                      ]
                    ),
                  ]),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _vm.currentReceipt
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.confirmDelete(true)
                },
                cancel: function ($event) {
                  return _vm.confirmDelete(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Order Receipt"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(_vm.currentReceipt.invoiceNo))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Order Receipt")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }